import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-magic-icon',
  templateUrl: './design-magic.component.html'
})
export class DesignMagicComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
